import { FormattedMessage } from 'react-intl';
import { PaloNextThemeProvider } from '@synergy/theme-palo';
import { PoolButton, PoolModal, PoolModalActions, PoolModalContent, PoolModalTitle } from '@synergy/components-next';
import { useParams } from 'react-router-dom';
import { useState } from 'react';

import { BonusSettlementSearchCustomer } from '../../detail/models/bonus-settlement-supplier-overview';
import { PoolCustomerBonusSettlementAutocompleteList } from '../../../../common/components/autocomplete-list/bonus-settlement-supplier-detail-customer-autocomplete-list/pool-bonus-settlement-supplier-detail-customer-autocomplete-list';
import { addCustomer } from '../store/bonus-settlements-supplier-detail-actions';
import { bonusSettlementsSupplierDetailSelector } from '../store/bonus-settlements-supplier-detail-selector';
import { useAppSelector } from '../../../../store/use-appstate-selector';
import { useThunkDispatch } from '../../../../store/use-thunk-dispatch';

interface BonusSettlementSupplierDetailAddCustomerModalProps {
    open: boolean;
    onClose: () => void;
}

export const BonusSettlementSupplierDetailAddCustomerModal = (
    props: BonusSettlementSupplierDetailAddCustomerModalProps
) => {
    const { open, onClose } = props;
    const dispatch = useThunkDispatch();
    const bonusSettlementSupplierDetail = useAppSelector(bonusSettlementsSupplierDetailSelector);
    const { bonusSettlementId, id: supplierBonusSettlementId } = useParams<{ bonusSettlementId: string; id: string }>();
    const [customer, setCustomer] = useState<BonusSettlementSearchCustomer | null>(null);

    const handleSave = () => {
        if (bonusSettlementId && supplierBonusSettlementId && customer) {
            dispatch(
                addCustomer({
                    bonusSettlementId: +bonusSettlementId,
                    supplierBonusSettlementId: +supplierBonusSettlementId,
                    customerId: customer.id,
                })
            );
            onClose();
        }
    };

    const handleClose = () => {
        setCustomer(null);
        onClose();
    };

    return (
        <PaloNextThemeProvider>
            <PoolModal open={open} onClose={handleClose}>
                <PoolModalTitle>
                    <FormattedMessage id="app.bonusSettlements.supplierDetail.addCustomer" />
                </PoolModalTitle>
                <PoolModalContent>
                    {bonusSettlementId && supplierBonusSettlementId && (
                        <PoolCustomerBonusSettlementAutocompleteList
                            onSelected={setCustomer}
                            label={<FormattedMessage id="app.demands.detail.participant" />}
                            required={true}
                            bonusSettlementId={+bonusSettlementId}
                            supplierBonusSettlementId={+supplierBonusSettlementId}
                        />
                    )}
                </PoolModalContent>
                <PoolModalActions>
                    <PoolButton variant="outlined" onClick={() => onClose()}>
                        <FormattedMessage id="app.common.close" />
                    </PoolButton>
                    <PoolButton
                        onClick={handleSave}
                        disabled={bonusSettlementSupplierDetail?.readOnly || customer === null}
                    >
                        <FormattedMessage id="app.common.save" />
                    </PoolButton>
                </PoolModalActions>
            </PoolModal>
        </PaloNextThemeProvider>
    );
};
